import type { IconData } from '@stacksjs/iconify-core'

export const treeF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 13.758v6.1a1 1 0 0 1-2 0v-6.1A5 5 0 0 1 2.118 4.77a5.002 5.002 0 0 1 9.764 0A5 5 0 0 1 8 13.758\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default treeF
